<template>
  <b-modal :id="`not-today${id}`" modal-class="modal-style" ref="modal">
    <template>
      <p class="modal-style-title alert-title">無法報到</p>
      <div class="modal-style-content">
        <p>非當日課程無法報到，請洽服務人員</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal() {
      if (this.modal == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`not-today${this.id}`);
      this.modal = !this.modal;
    }
  }
};
</script>
